module.exports = __webpack_public_path__ + "50abaf6734ed71696ff12771fa4525ea.pdf";